import usePrivateAxios from '@/common/api/usePrivateAxios'
import { getRailsUpdate } from '@/common/utils/getRailsUpdate'
import { mapToDeletion } from '@/common/utils/railsHelpers'
import { unFormatCurrency } from '@/common/utils/unFormatters'
import { CompanyPriceSurveyValidationSchema } from '@/features/privateCompanies/schemas/priceSurvey/create.schema'
import { CompanyPriceSurveyData } from '@/features/privateCompanies/types/companyPriceSurvey.type'
import { useMutation } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

interface UseUpdateCompanyPriceSurvey {
  companyPriceSurvey?: CompanyPriceSurveyData
  onSuccess: (response: AxiosResponse) => void
  onError: (error: AxiosError) => void
}

export const useUpdateCompanyPriceSurvey = ({
  companyPriceSurvey,
  onSuccess,
  onError,
}: UseUpdateCompanyPriceSurvey) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['updateCompanyPriceSurvey'],
    mutationFn: async (form: CompanyPriceSurveyValidationSchema) => {
      const price_survey = {
        survey_conducted_at: form.survey_conducted_at,
        geo_geoables_attributes: getRailsUpdate(
          companyPriceSurvey?.geo_geoables?.map((geo) => ({ ...geo, geo_type: 'Geo::City' })) || [],
          form?.geo_geoables_attributes?.map((geo) => ({ ...geo, geo_type: 'Geo::City' })) || [],
          (geo) => geo.geo.id,
          (geo) => geo.value || '',
          mapToDeletion,
          (geo) => ({ geo_id: geo.value, geo_type: 'Geo::City' }),
        ),
        price_survey_products_attributes: [
          ...getRailsUpdate(
            companyPriceSurvey?.price_survey_products || [],
            form?.price_survey_products_attributes || [],
            (product) => product.product.id,
            (product) => product.product_id || '',
            mapToDeletion,
            (value) => ({ ...value, price: unFormatCurrency(value.price || '0') }),
          ),
          ...(form?.price_survey_products_attributes
            ?.filter((product) => !!product.id)
            ?.map((product) => ({ id: product.id, price: unFormatCurrency(product.price || '0') })) || []),
        ],
        evidences_attachments_attributes: getRailsUpdate(
          companyPriceSurvey?.evidences || [],
          form?.evidences_attachments_attributes || [],
          (attachment) => attachment.id,
          (attachment) => attachment.id,
          mapToDeletion,
          (attachment) => ({ blob_id: attachment.id }),
        ),
      }

      return privateAxios.put(`/client/price_surveys/${companyPriceSurvey?.id}`, { price_survey })
    },
    onSuccess,
    onError,
  })
}
